import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Text,
    View,
    TouchableOpacity,
    ScrollView,
    Image
} from 'react-native'

import { push } from 'react-router-redux'
import styles from './styles'

import Profile from '../../components/profile/index'
import Listings from '../../components/listings/index'
import { WeeklyRanges, WeeklyTotals } from '../../components/weekly/index'
import Modal from '../../components/modal/index'
import EmptyCard from '../../components/cardEmpty/index'
import ErrorCard from '../../components/cardError/index'
import LoadingCard from '../../components/cardLoading/index'

import CONSTANTS from '../../constants/constants'

import {
    stateGetIn,
    stateGetInToJS,
    getAvatar
} from '../../lib/index'

import MainReducer from '../main/reducer'
import ListboardReducer from './reducer'

const LAST_TRANSACTION_COUNT = 250

class ListBoard extends Component {
    static NAME = 'ListBoard'

    constructor(props) {
        super(props)

        this.state = {
            width: 0,
            height: 0,
            toolTip: false,
            period: null,
            transactions: null,
            modalOpen: false,
            modalType: null
        }
    }

    componentDidMount() {
        this.checkProfileSettings()
        this.props.fetchFullTransactions(LAST_TRANSACTION_COUNT)
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.modalType) {
            return {
                modalOpen: true,
                modalType: nextProps.modalType
            }
        } else {
            return null
        }
    }

    openModal(modalKind = 'modal', modalType = null, period = null) {
        this.setState({
            toolTip: 'modal' === modalKind ? false : true,
            period: period,
            modalOpen: 'modal' === modalKind ? true : false,
            modalType: modalType
        })
    }

    closeModal = () => {
        this.setState({ period: null, toolTip: false, modalOpen: false, modalType: null })

        if ('/' !== this.props.path.split('/')[1]) {
            this.props.goHome()
        }
    }

    onLayout(layout) {
        this.setState((state, props) => {
            return {
                width: layout.width,
                height: layout.height
            }
        })
    }

    checkProfileSettings() {
        if (
            !this.props.user.userSettings.version ||
            20210216 !== this.props.user.userSettings.version
        ) {
            this.props.resetProfileSettings()
        }
    }

    onPressWeekly = (ranges) => {
        this.closeModal()
        this.props.fetchWeeklyTransactions(ranges.start, ranges.end)
        this.openModal('toolTip', 'totals', ranges)
    }

    render() {
        const {
            isFullLoading,
            error,
            user,
            fullTransactions,
            noFullTransactions,
            isWeeklyLoading,
            weeklyTransactions,
            noWeeklyTransactions,
            environment,
            streetAddr
        } = this.props

        const {
            width,
            height,
            period,
            toolTip,
            modalOpen,
            modalType
        } = this.state

        const currentIdentityBadge = getAvatar(user.currentIdentity)

        let status = 'loading'
        if (error) {
            status = 'error'
        } else if (noFullTransactions) {
            status = 'empty'
        } else if (fullTransactions) {
            status = 'fetched'
        }

        return (
            <View style={styles.container}
                onLayout={(evt) => { this.onLayout(evt.nativeEvent.layout) }}>

                <View style={{
                        flex: 2,
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        alignSelf: 'stretch'
                    }}>
                    <View style={styles.avatar}>
                        <TouchableOpacity
                            onPress={() => { this.openModal('modal', 'profile', null) }}
                            activeOpacity={0.8}>
                                <View style={styles.identity}>
                                    <View style={[currentIdentityBadge.badgeStyle, styles.badgeStyle]}>
                                        <Image style={styles.badgeImageStyle}
                                            source={currentIdentityBadge.badgeImage} />
                                    </View>
                                    <View style={{ flexDirection: 'column' }}>
                                        <Text style={styles.username}>
                                            {user.currentIdentity && user.currentIdentity.name
                                                ? user.currentIdentity.name
                                                : 'Meet Carrot Merchant'}
                                        </Text>
                                        {streetAddr && streetAddr.value && <Text style={styles.street}>
                                            {streetAddr.value}
                                        </Text>}
                                    </View>
                                </View>
                        </TouchableOpacity>
                    </View>

                    <View style={styles.statement}>
                        <TouchableOpacity
                            onPress={() => { this.openModal('toolTip', 'weekly', null) }}
                            activeOpacity={0.8}>
                                <View style={styles.identity}>
                                    <Image style={styles.statementImg}
                                        source={require('../../images/statement.png')} />
                                    <Text style={styles.statementTxt}>
                                        Historical Statements
                                    </Text>
                                </View>
                        </TouchableOpacity>
                    </View>
                </View>

                <View style={{
                        flex: 1,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        alignSelf: 'stretch'
                    }}>
                    <View style={styles.byline}>
                        <Text style={styles.bylineTxt}>
                            Transactions
                        </Text>

                        <View style={{ flexDirection: 'column'}}>
                            <View style={{ flexDirection: 'row'}}>
                                <View style={styles.dotNew} />
                                <Text style={styles.byline2Txt}>
                                    New Customers
                                </Text>
                            </View>
                            <View style={{ flexDirection: 'row'}}>
                                <View style={styles.dotRecurring} />
                                <Text style={styles.byline2Txt}>
                                    Recurring Customers
                                </Text>
                            </View>
                        </View>
                    </View>

                    <View>
                        <Text style={styles.bylineTxt}>
                            Cashback &amp; Fees
                        </Text>
                    </View>
                </View>

                {('loading' === status || isFullLoading) &&
                    <View style={styles.cardStyle}>
                        <LoadingCard
                            cardStyle={{
                                width: ~~(0.75*width),
                                height: ~~(0.6*height),
                                shadowColor: '#ffffff',
                                shadowRadius: 0,
                                shadowOffset: { width: 0, height: 0 }
                            }} />
                    </View>}

                {'empty' === status && !isFullLoading &&
                    <View style={styles.cardStyle}>
                        <EmptyCard
                            cardStyle={{
                                width: ~~(0.75*width),
                                height: ~~(0.6*height),
                                shadowColor: '#ffffff',
                                shadowRadius: 0,
                                shadowOffset: { width: 0, height: 0 }
                            }} />
                    </View>}

                {'error' === status && !isFullLoading &&
                    <View style={styles.cardStyle}>
                        <ErrorCard
                            cardStyle={{
                                width: ~~(0.75*width),
                                height: ~~(0.6*height),
                                backgroundColor: '#ffffff',
                                borderColor: '#ffffff',
                                borderWidth: 0,
                                shadowColor: '#ffffff',
                                shadowRadius: 0,
                                shadowOffset: { width: 0, height: 0 }
                            }} />
                    </View>}

                {'fetched' === status && !isFullLoading && <View
                    style={{ flex: 8, alignSelf: 'stretch' }}>
                    <ScrollView
                        contentContainerStyle={{ alignItems: 'center', paddingRight: 10}}
                        horizontal={false}>

                        <Listings
                            isFullLoading={isFullLoading}
                            transactions={fullTransactions} />

                    </ScrollView>
                </View>}

                <View style={styles.datePicker}>
                    <TouchableOpacity
                        style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}
                        onPress={() => { this.openModal('toolTip', 'weekly', null) }}
                        activeOpacity={0.8}>
                        <Text style={styles.datePickerText}>
                            last {LAST_TRANSACTION_COUNT} transactions only. use historical statements for more.
                        </Text>
                    </TouchableOpacity>
                </View>

                {environment && 'live' !== environment &&
                    <View style={{ position: 'absolute', bottom: 10}}>
                        <Text style={{ fontSize: 14, color: 'red' }}>
                            {environment.toUpperCase()}
                        </Text>
                    </View>}

                <Modal
                    open={modalOpen}
                    closeOnTouchOutside={false}
                    // modalDidOpen={() => {
                    //     console.log('Modal did open.')
                    // }}
                    modalDidClose={() => {
                        this.closeModal()
                        // console.log('Modal did close.')
                    }}
                    // modalStyle={{
                    //     width,
                    //     height
                    // }}
                    containerStyle={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>

                    <View style={{ flex: 1, alignItems: 'center' }}>
                        {'profile' === modalType &&
                            <Profile onClose={this.closeModal} />}

                    </View>
                </Modal>

                <Modal
                    open={toolTip}
                    // modalDidOpen={() => {
                    //     console.log('Modal did open.')
                    // }}
                    animationDuration={100}
                    animationTension={0}
                    modalDidClose={() => {
                        this.closeModal()
                        // console.log('Modal did close.')
                    }}
                    modalStyle={{
                        width: '85%',
                        height: '80%'
                    }}
                    closeOnTouchOutside={true}
                    containerStyle={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>

                    <View style={{ flex: 1, alignItems: 'center' }}>
                        {'weekly' === modalType && <WeeklyRanges
                            onPress={this.onPressWeekly}
                            onClose={this.closeModal} />}

                        {'totals' === modalType && <WeeklyTotals
                            period={period}
                            isWeeklyLoading={isWeeklyLoading}
                            transactions={weeklyTransactions}
                            noWeeklyTransactions={noWeeklyTransactions}
                            onBack={() => this.openModal('toolTip', 'weekly', null)}
                            onClose={this.closeModal} />}
                    </View>
                </Modal>
            </View>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        path: state['router'].location.pathname,
        user: stateGetInToJS(state, MainReducer.NAME, ['user'], 'ListBoard'),
        isFullLoading: stateGetIn(state, ListboardReducer.NAME, ['fullLoading'], 'ListBoard') === true,
        error: stateGetIn(state, ListboardReducer.NAME, ['error'], 'ListBoard'),
        fullTransactions: stateGetInToJS(state, ListboardReducer.NAME, ['fullTransactions'], 'ListBoard', []),
        noFullTransactions: stateGetIn(state, ListboardReducer.NAME, ['noFullTransactions'], 'ListBoard') === true,
        isWeeklyLoading: stateGetIn(state, ListboardReducer.NAME, ['weeklyLoading'], 'ListBoard') === true,
        weeklyTransactions: stateGetInToJS(state, ListboardReducer.NAME, ['weeklyTransactions'], 'ListBoard', []),
        noWeeklyTransactions: stateGetIn(state, ListboardReducer.NAME, ['noWeeklyTransactions'], 'ListBoard') === true,
        environment: stateGetIn(state, MainReducer.NAME, ['environment'], 'ListBoard')
    }
}

const mapDispatchToProps = (dispatch) => ({
    clear: () => {
        dispatch(ListboardReducer.clear())
    },
    fetchFullTransactions: (count) => {
        dispatch(ListboardReducer.fetchFullTransactions(count))
    },
    fetchWeeklyTransactions: (
        start,
        end
    ) => {
        dispatch(ListboardReducer.fetchWeeklyTransactions(start, end))
    },
    goHome: () => {
        dispatch(push('/'))
    },
    resetProfileSettings: () => {
        dispatch(MainReducer.resetProfileSettings())
    }
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return Object.assign({}, ownProps, stateProps, dispatchProps, {
        admin: stateProps.user && stateProps.user.userSettings &&
                (stateProps.user.userSettings.carrotUser || stateProps.user.userSettings.adminOverride),
        streetAddr: stateProps.user && stateProps.user.endpoints &&
                    stateProps.user.endpoints.find((endpoint) => CONSTANTS.ENDPOINT_TYPES.ADDRESS === endpoint.endpoint_type)
    })
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ListBoard)



// WEBPACK FOOTER //
// ./src/containers/listboard/index.js